module.exports = __webpack_public_path__ + "img/ad-prototype.095b4732.png";